module.exports = __webpack_public_path__ + "static/media/Twitter.b54e7511.png";